<template>
  <div>
    <iframe
      title="Report Section"
      width="1140"
      height="541.25"
      src="https://app.powerbi.com/view?r=eyJrIjoiZjFlNDFlNTMtZDEyYS00MmUyLTlmODAtZTJiNjYzNjJhNjZmIiwidCI6IjA4ZjI1MDAzLWE0NWMtNDlmYi04MDkwLWE4ZTljNDU5MjVkNiJ9"
      frameborder="0"
      allowFullScreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
